// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reservation-policies__reservation-policy[data-v-2e69052a]{margin-bottom:2rem}.reservation-policies__reservation-policy h4[data-v-2e69052a]{font-size:14px;font-weight:bold;line-height:1;margin-bottom:0}.reservation-policies__reservation-policy p[data-v-2e69052a]{font-size:14px;margin-top:5px;line-height:1.5;margin-bottom:0}.reservation-policies__reservation-policy[data-v-2e69052a]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
